module.exports = __webpack_public_path__ + "img/Trail_Of_Crumbs-1.1341316e.gif";